<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },
                  {
                    title: 'Training Wizard',
                   
                  },
                  {
                    title: ` ${trainingTitle}`,
                    active: true,
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <!-- <h2>
                        <strong>Sign Up Your User Account</strong>
                    </h2>
                <p>Fill all form field to go to next step</p>-->
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li
                          @click="trainingAssignment()"
                          class="completed"
                          id="NewTraining"
                        >
                          <strong>Training Assignment</strong>
                        </li>
                        <li
                          @click="showPage2()"
                          :class="{ 'active' : active == 2 }"
                          id="PoAssignment"
                        >
                          <strong>P.O Assignment</strong>
                        </li>
                        <li
                          @click="trainingInformation()"
                          :class="{ 'active' : active == 3 }"
                          id="TrainingInformation"
                        >
                          <strong>Event Information</strong>
                        </li>
                        <li
                          @click="trainerRegistration()"
                          :class="{ 'active' : active == 4 }"
                          id="TrainerRegistration"
                        >
                          <strong>Facilitators' Registration</strong>
                        </li>
                        <li
                          @click="trainingAgenda()"
                          :class="{ 'active' : active == 5 }"
                          id="TrainingAgenda"
                        >
                          <strong>Training Agenda</strong>
                        </li>
                        <li
                          @click="uploadMaterial()"
                          :class="{ 'active' : active == 6 }"
                          id="Trainingmaterial"
                        >
                          <strong>Upload Material</strong>
                        </li>
                        <li
                          @click="assessmentFunction()"
                          :class="{ 'active' : active == 7 }"
                          id="TrainingAssessments"
                        >
                          <strong>Assessments</strong>
                        </li>

                        <li
                          @click="traineeRegFunction()"
                          :class="{ 'active' : active == 8 }"
                          id="TraineeRegistration"
                        >
                          <strong>Participants' Registration</strong>
                        </li>
                        <li
                          @click="assessmentReviewFunction()"
                          :class="{ 'active' : active == 9 }"
                          id="AssessmentReview"
                        >
                          <strong>Assessment Review</strong>
                        </li>
                        <li
                          @click="trainingCompletionFunction()"
                          :class="{ 'active' : active == 10 }"
                          id="Completion"
                        >
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset
                        v-if="adminPage2 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Training Assignment</h5>
                        <!-- row 1 starts  -->
                        <div class="row mt-5">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Training Title</label
                              >
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                :value="updateTraining?.training?.title"
                                disabled
                                id="first"
                              />
                            </div>
                          </div>

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Project</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1"
                                disabled
                              >
                                <option selected>
                                  {{ updateTraining?.training?.project?.title }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <!-- row 1 ends -->
                        <!-- row 2 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Sub Programme</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1"
                                disabled
                              >
                                <option selected>
                                  {{ updateTraining?.training?.subprogram?.title }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Assigned Advisor</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1"
                                disabled
                              >
                                <option selected>
                                  {{ updateTraining?.training?.advisor?.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <!-- row 2 ends -->
                        <!-- row 3 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Select Program Officer</label
                            >
                            <selectize
                              id="select-state"
                              v-model="officerSelected"
                              :searchable="true"
                              disabled
                            >
                              <option
                                v-for="(item, index) in programOfficerAssign"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="padding-left: 5px;font-size:.85rem;"
                              >Donor Name</label
                            >
                            <selectize
                              id="select-state"
                              v-model="fundingAgencySelected"
                              :settings="donersettings"
                              disabled
                            >
                              <option
                                v-for="(item, index) in donernameArr"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.title }}
                              </option>
                            </selectize>
                          </div>
                        </div>
                        <div class="row">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Thematic Area
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state"
                              v-model="thematicareaSelectedUpdate"
                              :settings="thematicareasettings"
                              disabled
                            >
                              <option
                                v-for="(item, index) in valuesArray"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Select Date Range
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff"
                              placeholder="Start date Range *"
                              v-model="dateRange"
                              :config="dateOptions"
                              disabled
                            ></flat-pickr>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Training Outcome</label
                            >
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="outcome"
                              id="outcome"
                            />
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Training Output</label
                            >
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="output"
                              id="output"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="floating-label">
                              <label style="font-weight:700;" for="first">
                                No of days
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <input
                                disabled
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >event</i
                                >
                              </span>
                            </div>
                          </div>
                        </div>
                        <!-- row 3 ends  -->

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <router-link
                              to="/dashboard/admin/trainingWizard"
                              class="btn btn-primary btn-sm m-1 pt-2"
                            >
                              Back
                            </router-link>
                            <button
                              type="button"
                              v-on:click="trainingInformation()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage3 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Training Information</h5>
                        <!-- row 1 starts  -->
                        <div class="row mt-5">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Training Title</label
                              >
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                disabled
                                id="first"
                                :value="updateTraining?.training?.title"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Sub Program</label
                              >
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                disabled
                                id="first"
                                :value="updateTraining?.training?.subprogram?.title"
                              />
                            </div>
                          </div>
                          <!--  col-md-6   -->
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Project</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1"
                                disabled
                              >
                                <option
                                  :value="updateTraining?.training?.project?.id"
                                  selected
                                >
                                  {{updateTraining?.training?.project?.title}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Donor Name</label
                              >
                              <selectize
                                id="select-state"
                                disabled
                                v-model="donerSelected"
                                :settings="donersettings"
                              >
                                <option
                                  v-for="(item,index) in selectedDoner"
                                  :key="index"
                                  :value="item.id"
                                  disabled
                                >
                                  {{item.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                        </div>
                        <!-- row 1 ends -->
                        <!-- row 2 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Department</label
                              >
                              <selectize
                                id="select-state"
                                v-model="department"
                                :settings="departmentsettings"
                                disabled
                              >
                                <option
                                  v-for="(item,index) in departmentArr"
                                  :key="index"
                                  :value="item.id"
                                >
                                  {{item.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Type</label
                              >
                              <selectize v-model="type_training" disabled>
                                <!-- settings is optional -->
                                <option
                                  v-for="(tType,index) in trainingTypeArr"
                                  :key="index"
                                  :value="tType.id"
                                >
                                  {{tType.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                        </div>
                        <!-- row 2 ends -->
                        <!-- row 3 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Date Range</label
                              >
                              <flat-pickr
                                class="form-control"
                                style="background: #fff"
                                placeholder="Start date Range"
                                v-model="dateRange"
                                :config="dateOptions"
                                disabled
                              ></flat-pickr>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Days</label
                              >
                              <input
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                disabled
                                placeholder=" "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Location</label
                            >
                            <selectize
                              id="select-state"
                              v-model="district"
                              disabled
                            >
                              <option
                                v-for="(item,index) in cityArr"
                                :key="index"
                                :value="item.id"
                              >
                                {{item?.title}}, {{item?.province?.title}},
                                {{item?.province?.country?.title}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Contact Person
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <input
                              class="floating-input form-control"
                              v-model="contact_person"
                              type="text"
                              placeholder=" "
                              disabled
                            />
                          </div>
                          <div
                            class="col-md-6 col-lg-6"
                            style="margin-top:10px;"
                          >
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="contact_number"
                                type="text"
                                v-mask="'(9999) 9999999'"
                                placeholder=" "
                                disabled
                              />
                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >call</i
                                >
                              </span>
                              <label class="lbl-label">
                                Contact Number
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- email starts -->
                          <div class="col-md-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="contact_email"
                                type="email"
                                placeholder=" "
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >email</i
                                >
                              </span>
                              <label class="lbl-label">
                                Email
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- email ends -->
                          <!-- floating input ends -->
                        </div>
                        <div class="row">
                          <!-- floating input starts -->
                          <div class="col-md-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="address"
                                type="text"
                                placeholder=" "
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >place</i
                                >
                              </span>
                              <label class="lbl-label">
                                Address
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                          <!-- Address Ends -->
                          <!-- floating input starts -->
                          <div
                            class="col-md-12 col-lg-12"
                            style="margin-top:10px;"
                          >
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="venue"
                                type="text"
                                placeholder=" "
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >account_balance</i
                                >
                              </span>
                              <label class="lbl-label">
                                Venue
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="showPage2()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="trainerRegistration()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <div v-if="adminPage4 == true">
                        <TrainerView />

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="trainingInformation()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="trainingAgenda()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </div>
                      <div v-if="adminPage5 == true">
                        <TrainingAgenda />

                        <!-- row 1 starts  -->
                        <div>
                          <div class="row">
                            <div class="col-md-12 text-right">
                              <button
                                type="button"
                                v-on:click="trainerRegistration()"
                                class="btn btn-primary btn-sm m-1"
                              >
                                Back
                              </button>
                              <button
                                type="button"
                                v-on:click="uploadMaterial()"
                                class="btn btn-primary btn-sm"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </div>
                      <div v-if="adminPage6 == true">
                        <UploadMaterial />

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="trainingAgenda()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="assessmentFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                        <!-- Next Step Button Ends  -->
                      </div>
                      <div v-if="adminPage7 == true">
                        <TrainingAssessment />

                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="uploadMaterial()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="traineeRegFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>

                      <div v-if="adminPage8 == true">
                        <TraineeRegistration />
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="assessmentFunction()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="assessmentReviewFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </div>
                      <div v-if="adminPage9 == true">
                        <AssessmentReview />
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="traineeRegFunction()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="trainingCompletionFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                        <!-- Next Step Button Ends  -->
                      </div>
                      <fieldset
                        v-if="adminPage10 == true"
                        style="text-align: left;padding: 30px; min-height: 300px"
                      >
                        <span
                          v-if="this.training_status.preassesment_status == 1 && this.training_status.postassesment_status == 1"
                        >
                          <h5 class="text-center text-success mt-5">
                            <i class="material-icons">check</i> This training
                            has been setup successfully!
                          </h5>
                        </span>
                        <span class="mt-3" v-else>
                          <h5 class="text-center text-danger">
                            Warning! This Training is not completed and still
                            In-Progress
                          </h5>
                          <hr />
                          <li
                            class="text-success"
                            v-if="this.training_status.preassesment_status == 1"
                          >
                            <i class="material-icons">check</i> Pre Assessment
                            is enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Pre Assessment
                            is not enabled yet.
                          </li>
                          <li
                            class="text-success"
                            v-if="this.training_status.postassesment_status == 1"
                          >
                            <i class="material-icons">check</i> Post Assessment
                            is enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Post Assessment
                            is not enabled yet.
                          </li>
                          <li
                            class="text-success"
                            v-if="this.training_status.feedbackstatus == 1"
                          >
                            <i class="material-icons">check</i> Feedback is
                            enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Feedback is not
                            enabled yet.
                          </li>
                          <hr />
                        </span>
                        <!-- row 1 starts  -->
                        <div
                          class="row mt-5 mb-1 d-flex justify-content-center"
                        >
                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                              path:
                                '/dashboard/admin/brief_training_report',
                              query: { trainingId: this.trainingCode }
                            }"
                              class="white-text"
                              >Brief Training Details
                            </router-link>
                          </button>

                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/admin/analysis-report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Overall Training Analysis</router-link
                            >
                          </button>

                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/admin/individual_analysis_report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Individual Training Analysis</router-link
                            >
                          </button>
                          <button class="btn btn-primary float-right ml-3">
                            <div @click="getReport">
                              Download Training Report
                            </div>
                          </button>
                        </div>

                        <div class="row d-flex justify-content-center mt-4">
                          <button
                            class="btn btn-info float-right"
                            @click="printSheet"
                          >
                            Attendance Sheet
                            <i class="material-icons" style="font-size: 20px;"
                              >people</i
                            >
                          </button>
                        </div>
                        <!-- row 1 ends -->
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template>
            <div>
              <div id="attendance-sheet">
                <div class="header">
                  <img
                    :src="BASEPATHDYNAMIC+'/unodc_logo.png'"
                    alt="UNODC Logo"
                  />
                  <h2>Training Attendance Sheet</h2>
                </div>

                <p class="address">
                  G-5, Islamabad, Phone: (051) 2601461 <br />UNODC COAPK, Plot#
                  5, Diplomatic Enclave
                </p>

                <table>
                  <tr>
                    <th colspan="4" style="text-align: left;">
                      Training Title:
                      {{attendanceData?.trainingResponse?.title}}
                    </th>
                    <th colspan="3" style="text-align: left;">
                      Training Dates:
                      {{formattedDate(attendanceData?.trainingResponse?.startdate)}}
                      to
                      {{formattedDate(attendanceData?.trainingResponse?.enddate)}}
                    </th>
                  </tr>
                  <tr>
                    <th colspan="4" style="text-align: left;">
                      Event Venue: {{attendanceData?.trainingResponse?.venue}}
                    </th>
                    <th colspan="3" style="text-align: left;">
                      Total No. of Participants: (___________)
                    </th>
                  </tr>
                </table>
                <br />
                <table>
                  <tr>
                    <th colspan="5" class="list_name">Trainees</th>
                    <th :colspan="attendanceData?.trainingResponse?.noofdays">
                      Signature
                    </th>
                  </tr>
                  <tr>
                    <th>S#</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Designation</th>
                    <th>Mobile No</th>
                    <th
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'day-' + day"
                    >
                      Day-{{ day }}
                    </th>
                  </tr>
                  <tr
                    v-for="(user, index) in attendanceData.traineeResponse"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.name ?? ' '}}</td>
                    <td>{{ user.department[0]?.title ?? ' '}}</td>
                    <td>{{user.designation[0]?.title ?? ' '}}</td>
                    <td>{{user.contactNo }}</td>
                    <td
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'user-day-' + index + '-' + day"
                    ></td>
                  </tr>
                  <tr v-for="emptyIndex in 10" :key="'empty-' + emptyIndex">
                    <td>
                      {{ attendanceData?.traineeResponse?.length + emptyIndex }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'empty-day-' + emptyIndex + '-' + day"
                    ></td>
                  </tr>
                </table>
                <br />
                <table>
                  <tr>
                    <th colspan="5" class="list_name">UNODC Staff</th>
                    <th :colspan="attendanceData?.trainingResponse?.noofdays">
                      Signature
                    </th>
                  </tr>
                  <tr>
                    <th>S#</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Designation</th>
                    <th>Mobile No</th>
                    <th
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'day-' + day"
                    >
                      Day-{{ day }}
                    </th>
                  </tr>
                  <tr
                    v-for="(user, index) in attendanceData.trainerResponse"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ user?.trainer?.name ?? ' '}}</td>
                    <td>{{ user?.trainer?.organization ?? ' '}}</td>
                    <td>
                      {{getDesignationTitle(user?.trainer?.designation)}}
                    </td>
                    <td>{{user.trainer.mobile ?? ' '}}</td>
                    <td
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'empty-day-' + emptyIndex + '-' + day"
                    ></td>
                  </tr>
                  <tr v-for="emptyIndex in 2" :key="'empty-' + emptyIndex">
                    <td>
                      {{ attendanceData?.trainerResponse?.length + emptyIndex }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'empty-day-' + emptyIndex + '-' + day"
                    ></td>
                  </tr>
                </table>
                <br />
                <table>
                  <tr>
                    <th colspan="5" class="list_name">Supporting Staff</th>
                    <th :colspan="attendanceData?.trainingResponse?.noofdays">
                      Signature
                    </th>
                  </tr>
                  <tr>
                    <th>S#</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Designation</th>
                    <th>Mobile No</th>
                    <th
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'day-' + day"
                    >
                      Day-{{ day }}
                    </th>
                  </tr>

                  <tr v-for="emptyIndex in 3" :key="'empty-' + emptyIndex">
                    <td>
                      {{ emptyIndex }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'empty-day-' + emptyIndex + '-' + day"
                    ></td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import { downloadTrainingReport} from '../../../utils/DownloadReport';
import TrainerView from './TrainingEdit/trainerRegistration';
import TrainingAgenda from './TrainingEdit/trainingAgenda';
import UploadMaterial from './TrainingEdit/uploadMaterial';
import TrainingAssessment from './TrainingEdit/trainingAssessment';
import TraineeRegistration from './TrainingEdit/traineeRegistration';
import AssessmentReview from './TrainingEdit/assessmentReview'

export default {
  data: () => ({
    BASEPATHDYNAMIC: localStorage.getItem("BASE_PATH"),
    attendanceData:[],
    outcome:"",
    output:"",
    trainingTitle:"",
    isSidebar: false,
    trainingId: "",
    trainingCode: "",
    updateTraining: [],
    officerSelected: "",
    update_training_id: "",
    dateRange: [],
    dateOptions: {
      wrap: true,
      weekNumbers: true,
      mode: "range",
      maxDate: new Date().fp_incr(9),
      dateFormat: "d-m-Y"
    },
    fundingAgencySelected: [],
    donersettings: {
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    donernameArr: [],
    thematicareaSelectedUpdate: [],
    thematicareasettings: {
      maxItems: 10,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    startdate: "",
    startDate: "",
    endDate: "",
    programOfficerAssign: [],
    project: "",
    advisor: "",
    subprogram: "",
    enddate: "",
    valuesArray: [],
    noOfDays: "",
    isDataEdit: 0,
    active: 2,
    type_training: "",
    country: "",
    province: "",
    district: "",
    department: [],
    departmentsettings: {
      maxItems: 10,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    // project_title: 1,
    trainingtitleArr: [],
    projecttitleArr: [],
    cityArr: [],
    createdTrainingss: "",
    trainingTypeArr: [],
    countryArr: [],
    provinceArr: [],
    contact_number: "",
    contact_email: "",
    contact_person: "",
    departmentArr: [],
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    textarea: "",
    venue: "",
    donerSelected: [],
    selectedDoner: [],
    newTrainer: [],
    foundAgenda: [],
    materialRecords: [],

    // pre & post assessments
    existPreassessmentForm: false,
    showAssessmentTable: false,
    easyPercent: 0,
    mediumPercent: 0,
    hardPercent: 0,
    assessmentShowArr: [],
    // End of pre & post
    // Starts of Trainer feedback
    existTrainerFeedbackForm: false,
    trainerFeedbackShowArr: [],
    // End of Trainer feedback

    // Trainee
    traineeFeedbackShowArr: [],
    existTraineeFeedForm: false,
    // End of Trainee
    itemsTrainee: [],
    itemsTraineeReview: [],
    training_status: "",
    adminPage2: true,
    adminPage3: false,
    adminPage4: false,
    adminPage5: false,
    adminPage6: false,
    adminPage7: false,
    adminPage8: false,
    adminPage9: false,
    adminPage10: false,
    designationArr:[],
  }),
  created() {
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/training/advisor/" +
          this.$route.query.trainingId +
          "/edit"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response) {
          this.trainingId = response.data.training.id;
          this.training_status = response.data.training;
          this.thematicareaSelectedUpdate = [];
          this.fundingAgencySelected = [];
          this.officerSelected = [];
          // this.freqUpdateArr =[];
          if(response.data && response.data.thematic != ""){
            response.data.thematic.forEach(dnr => {
              this.thematicareaSelectedUpdate.push(dnr.id);
            });
          }
          if(response.data && response.data.fundingagency != ""){
            response.data.fundingagency.forEach(dnr => {
              this.fundingAgencySelected.push(dnr.id);
            });
          }
          response.data.officer.forEach(dnr => {
            this.officerSelected.push(dnr.id);
          });
          if (
            response.data.training != "" &&
            response.data.training.TrainingDates != undefined &&
            response.data.training.TrainingDates != ""
          ) {
            JSON.parse(response.data.training.TrainingDates).forEach(
              element => {
                if (
                  element.startDate != undefined &&
                  element.endDate != undefined &&
                  element.endDate != "" &&
                  element.startDate != ""
                ) {
                  this.freqUpdateArr.push({
                    startDate: element.startDate,
                    endDate: element.endDate
                  });
                }
              }
            );
          }

          this.noOfDays = response?.data?.training?.noofdays;
          this.freqLimit = response?.data?.training?.frequency;
        }
      });
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.showPage2();

    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/programofficer/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.programOfficerAssign = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/donernames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.donernameArr = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/thematics/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      });

      //designation
    axios
      .get(localStorage.getItem("BASE_PATH") + "/designations/get")
      .then((response) => {
        this.designationArr = response.data;
      });

  },

  methods: {
     formattedDate(tdate) {
      const [year, month, day] = tdate.split("-");
      return `${day}-${month}-${year}`;
    },
    // step 1
    trainingAssignment(){
      this.$router.push('/dashboard/admin/trainingWizard');
    },
    // show step 2
    showPage2(){
    this.openLoading();
    this.adminPage2 = true;
    this.adminPage3 = false;
    this.adminPage4 = false;
    this.adminPage5 = false;
    this.adminPage6 = false;
    this.adminPage7 = false;
    this.adminPage8 = false;
    this.adminPage9 = false;
    this.adminPage10 = false;
    this.active = 2;
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/advisor/trainingsingle/get/" +
          this.trainingCode

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingTitle = response?.data?.training?.title,
        this.updateTraining = response?.data;
        this.update_training_id = response?.data?.id;
        const tId = response?.data?.training?.id;
        this.outcome = response?.data?.training?.outcome ?? '';
        this.output = response?.data?.training?.output ?? '';
         this.getAttendance(tId);
        if (response.data.project != undefined) {
          this.project = response?.data?.project?.title;
        }
        if (response.data.subprogram) {
          this.subprogram = response?.data?.subprogram?.title;
        }
        if (response.data.advisor) {
          this.advisor = response?.data?.advisor?.name;
        }
        this.dateRange =
          this.updateTraining?.training?.startdate + " to " + this.updateTraining?.training?.enddate;
      });

    },
    // step 3
    trainingInformation(){
      this.adminPage2 = false;
      this.adminPage3 = true;
      this.adminPage4 = false;
      this.adminPage5 = false;
      this.adminPage6 = false;
      this.adminPage7 = false;
      this.adminPage8 = false;
      this.adminPage9 = false;
      this.adminPage10 = false;
      this.active = 3;
      this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
        )
        .then(async response => {

          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();

        await this.adminCountry();
        await this.adminProvince();
        await this.adminDistricts();
        await this.adminDepartment();
        await this.adminTrainingType();

        if(response.data && response.data.doner != undefined){
          this.selectedDoner = response.data.doner;
        }
        response.data.doner.forEach(dnr => {
          this.donerSelected.push(dnr.id);
        });
        if (response.data.training.typetraining_id != null) {
          this.type_training = response.data.training.typetraining_id;
        }
        if (
          response?.data?.training != undefined &&
          response?.data?.training != null &&
          response?.data?.training?.noofdays
        ) {
          this.noOfDays = response?.data?.training?.noofdays;
        }
        if (
          response.data.training.startdate != null &&
          response.data.training.enddate != null
        ) {
          this.dateRange =
            response.data.training.startdate +
            " to " +
            response.data.training.enddate;
        }
        if (response.data.training.district_id != null) {
          this.district = response.data.training.district_id;
        }
        if (response.data.training.contact_person != null) {
          this.contact_person = response.data.training.contact_person;
        }
        if (response.data.training.contact_number != null) {
          this.contact_number = response.data.training.contact_number;
        }
        if (response.data.training.email != null) {
          this.contact_email = response.data.training.email;
        }
        if (response.data.training.address != null) {
          this.address = response.data.training.address;
        }
        if (response.data.training.venue != null) {
          this.venue = response.data.training.venue;
        }

        if (response.data.departments && response.data.departments != "") {
          response.data.departments.forEach(department => {
            this.department.push(department.id);
          });
        }
        // this.type_training = response.data.trainingtype.title;
      });
    },
    // step 4
    trainerRegistration(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = true;
      this.adminPage5 = false;
      this.adminPage6 = false;
      this.adminPage7 = false;
      this.adminPage8 = false;
      this.adminPage9 = false;
      this.adminPage10 = false;
      this.active = 4;
      this.newTrainer = [];
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainer/show/training/" +
            this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if(response.data != null)
          this.newTrainer = response.data;
        });
    },
    // step 5
    trainingAgenda(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = false;
      this.adminPage5 = true;
      this.adminPage6 = false;
      this.adminPage7 = false;
      this.adminPage8 = false;
      this.adminPage9 = false;
      this.adminPage10 = false;
      this.active = 5;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/check/traninig/agenda/" +
            this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data && response.data.foundagenda != null) {
            this.foundAgenda = response.data.foundagenda;
          } else {
            this.foundAgenda = [];
          }
        });
    },
    // step 6
    uploadMaterial(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = false;
      this.adminPage5 = false;
      this.adminPage6 = true;
      this.adminPage7 = false;
      this.adminPage8 = false;
      this.adminPage9 = false;
      this.adminPage10 = false;
      this.active = 6;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/admin/training_material/get/"+this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.materials) {
            this.materialRecords = response.data.materials;
          }
        });
    },
    // step 7
    assessmentFunction(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = false;
      this.adminPage5 = false;
      this.adminPage6 = false;
      this.adminPage7 = true;
      this.adminPage8 = false;
      this.adminPage9 = false;
      this.adminPage10 = false;
      this.active = 7;
      this.showAssessment();
      this.showTraineeFeedback();
      this.showTrainerFeedback();
    },
    // step 8
    traineeRegFunction(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = false;
      this.adminPage5 = false;
      this.adminPage6 = false;
      this.adminPage7 = false;
      this.adminPage8 = true;
      this.adminPage9 = false;
      this.adminPage10 = false;
      this.active = 8;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.itemsTrainee = response.data;
        });
    },
    // step 9
    assessmentReviewFunction(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = false;
      this.adminPage5 = false;
      this.adminPage6 = false;
      this.adminPage7 = false;
      this.adminPage8 = false;
      this.adminPage9 = true;
      this.adminPage10 = false;
      this.active = 9;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.itemsTraineeReview = response.data;
        });
    },

    // step 10 completion
    trainingCompletionFunction(){
      this.adminPage2 = false;
      this.adminPage3 = false;
      this.adminPage4 = false;
      this.adminPage5 = false;
      this.adminPage6 = false;
      this.adminPage7 = false;
      this.adminPage8 = false;
      this.adminPage9 = false;
      this.adminPage10 = true;
      this.active = 10;
    },

    // this will show assessment which has been added
    showAssessment: function showAssessment() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/program-officer/training/assessment/" +
            this.trainingId +
            "/show"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.assessmentShowArr = response.data;
          this.showAssessmentTable = true;
        });
    },
    // this will show trainee feedback which has been added
    showTraineeFeedback: function showTraineeFeedback() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/program-officer/training/trainee-feedback/" +
            this.trainingId +
            "/show"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.traineeFeedbackShowArr = response.data;
        });
    },
    // this will show trainer feedback which has been added
    showTrainerFeedback: function showTrainerFeedback() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/program-officer/training/trainer-feedback/" +
            this.trainingId +
            "/show"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainerFeedbackShowArr = response.data;
        });
    },
    // step 3 functions
    adminCountry(){
    this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/countries/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.countryArr = response.data;
        });
    },
    //select all provinces
    adminProvince(){
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      });
    },
    //select all district
    adminDistricts(){
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.cityArr = response.data;
      });
    },
    //select all department
    adminDepartment(){
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.departmentArr = response.data;
      });
    },
    //select all training type
    adminTrainingType(){
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainingtype/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingTypeArr = response.data;
      });
    },
    // End of step 3
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
     getReport(){
         downloadTrainingReport(this.trainingCode)
      },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
     getAttendance(tId) {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/training/get-attendance/" + tId
        )
        .then((response) => {
          this.closeLoading();
          this.attendanceData = response.data;

        });
    },

    printSheet: function () {
            const printContents = document.getElementById("attendance-sheet").innerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.open();
            printWindow.document.write(`
                     <html>
    <head>
      <title>Print Sheet</title>
      <style>
        /* General styling */
        body { font-family: Arial, sans-serif; }

        /* Table styling */
        table {
          width: 100%;
          border-collapse: collapse;
        }
         td, tr {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
        th {
          border: 1px solid black;
          padding: 8px;
          text-align: center;
          background-color: #f2f2f2;
        }

        /* Header section styling */
        .header {
          justify-content: space-between;
          align-items: center;
        }
        h2 {
          text-align: center;
          text-decoration: underline;
        }
        .header img {
            width: 200px; /* Adjust the size of the image */
        }

        /* Address section */
        .address {
          font-size: 14px;
          margin-top: 0px;
          text-align: left;
        }

        /* List name styling */
        .list_name {
          font-size: 18px;
        }
      </style>
    </head>
    <body onload="window.print()">
      ${printContents}
    </body>
  </html>

    `);
            printWindow.document.close();

        },

  getDesignationTitle(designationId) {
        const match = this.designationArr?.find(
        (item) => item.id == designationId
      );
      return match ? match.title : '';
    },
  },
  watch: {

  },
  components: {
    Selectize,
    flatPickr,
    TrainerView,
    TrainingAgenda,
    UploadMaterial,
    TrainingAssessment,
    TraineeRegistration,
    AssessmentReview,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
.vs-breadcrumb {
  font-size: 18px !important;
  font-weight: 600 !important;
}
.btn-primary {
  font-size: 14px;
  height: 36px;
  background: #06a6e0;
  color: #ffffff;
  font-weight: 500;
  border-radius: 5px
}
.white-text {
  color: #ffffff;
}
.btn-primary:hover {
  background: #08769e;
}
.btn-info{
   height: 50px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px
}
#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #e8e8e8;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}
#progressbar .completed {
  color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0;
}


#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
  text-align:center;
  float:left;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}
#progressbar #TrainerRegistration:before {
  content: "4a";
}

#progressbar #TrainingAgenda:before {
  content: "4b";
}

#progressbar #Trainingmaterial:before {
  content: "4c";
}
#progressbar #TrainingAssessments:before {
  content: "4d";
}

#progressbar #TraineeRegistration:before {
  content: "4e";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}

#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}

/*Sheet style */
  table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td, tr {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
        }

        th {
            background-color: #f2f2f2;
        }
        .header {
            /* display: flex; */
            justify-content: space-between;
            align-items: center;

        }
        .header img {
            width: 200px; /* Adjust the size of the image */
        }
        h2 {
            text-align: center;
            text-decoration: underline;
        }
        .address {
            font-size: 14px;
            margin-top: 0px;
            text-align: left;
        }
        .list_name{
          font-size: 18px
        }

       #attendance-sheet {
  display: none;
}

/* Only show the attendance sheet when printing */
@media print {
  #attendance-sheet {
    display: block;
    position: relative;
    width: 100%;
    page-break-before: always; /* Ensure the sheet starts on a new page */
  }

  /* Hide everything else during printing */
  body * {
    visibility: hidden;
  }

  #attendance-sheet, #attendance-sheet * {
    visibility: visible;
  }

  #attendance-sheet {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
